module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_05 (12).c763e24.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_05 (12).mp4
// module id = 787
// module chunks = 1